import { gateway } from "src/gateway";
import { SuperAdminCompaniesResponse, SuperAdminCompany } from "../interfaces";

export const getSuperAdminCompanies = async (): Promise<SuperAdminCompany[]> => {
  const response = await gateway.get<SuperAdminCompaniesResponse>("/companies/admin");

  return response.data.data;
};
